import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MessageCircleIcon, UsersIcon, TrendingUpIcon, SearchIcon, FilterIcon, PlusIcon, ChevronRightIcon, MessageSquareIcon, HeartIcon, BookmarkIcon, ThumbsUpIcon, ThumbsDownIcon, UserIcon, TagIcon, BellIcon, SettingsIcon, ChevronDownIcon, LogInIcon, UserPlusIcon } from 'lucide-react';
const Forum = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const handleLogin = () => {
    // In a real implementation, this would navigate to the login page
    // For now, let's just toggle the login state for demonstration
    navigate('/register');
  };
  const categories = [{
    id: 'tech',
    name: 'Technology',
    topics: 243,
    posts: 1250
  }, {
    id: 'business',
    name: 'Business',
    topics: 187,
    posts: 980
  }, {
    id: 'education',
    name: 'Education',
    topics: 142,
    posts: 765
  }, {
    id: 'health',
    name: 'Health & Fitness',
    topics: 118,
    posts: 630
  }, {
    id: 'entertainment',
    name: 'Entertainment',
    topics: 98,
    posts: 520
  }, {
    id: 'food',
    name: 'Food & Dining',
    topics: 76,
    posts: 410
  }];
  const topics = [{
    id: '1',
    title: 'Recommendations for affordable co-working spaces in Nairobi?',
    author: 'JaneDoe',
    authorAvatar: '',
    category: 'Business',
    replies: 15,
    views: 134,
    lastActivity: '2 hours ago',
    isHot: true,
    isPinned: false
  }, {
    id: '2',
    title: 'What are your favorite local restaurants in Mombasa?',
    author: 'FoodieKE',
    authorAvatar: '',
    category: 'Food & Dining',
    replies: 27,
    views: 203,
    lastActivity: '5 hours ago',
    isHot: true,
    isPinned: false
  }, {
    id: '3',
    title: 'Tips for first-time hikers at Mt. Kenya',
    author: 'AdventureSeeker',
    authorAvatar: '',
    category: 'Health & Fitness',
    replies: 12,
    views: 98,
    lastActivity: '1 day ago',
    isHot: false,
    isPinned: true
  }, {
    id: '4',
    title: 'Discussing the latest tech innovations in Kenya',
    author: 'TechGuru',
    authorAvatar: '',
    category: 'Technology',
    replies: 32,
    views: 245,
    lastActivity: '3 hours ago',
    isHot: true,
    isPinned: false
  }, {
    id: '5',
    title: 'Best schools for computer science education in Kenya',
    author: 'EduExpert',
    authorAvatar: '',
    category: 'Education',
    replies: 18,
    views: 167,
    lastActivity: '12 hours ago',
    isHot: false,
    isPinned: false
  }];
  return <div className="pb-16" data-id="element-1939">
      <div className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800" data-id="element-1940">
        <div className="max-w-4xl mx-auto p-4" data-id="element-1941">
          <h1 className="text-2xl font-bold mb-2 flex items-center dark:text-gray-200" data-id="element-1942">
            <MessageCircleIcon className="w-6 h-6 mr-2" data-id="element-1943" />
            Forum
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-1944">
            Join discussions, ask questions, and connect with the community
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-4" data-id="element-1945">
        {/* Login Prompt for Non-Logged In Users */}
        {!isLoggedIn && <div className="bg-gray-50 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg p-4 mb-6 flex flex-col sm:flex-row items-center justify-between" data-id="element-1946">
            <div className="mb-4 sm:mb-0 text-center sm:text-left" data-id="element-1947">
              <h3 className="font-medium mb-1 dark:text-gray-200" data-id="element-1948">
                Join the conversation
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-1949">
                Sign in or create an account to post and reply to discussions
              </p>
            </div>
            <div className="flex space-x-3" data-id="element-1950">
              <button onClick={handleLogin} className="flex items-center px-4 py-2 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md text-sm" data-id="element-1951">
                <LogInIcon className="w-4 h-4 mr-2" data-id="element-1952" />
                Sign In
              </button>
              <Link to="/register" className="flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm dark:text-gray-200" data-id="element-1953">
                <UserPlusIcon className="w-4 h-4 mr-2" data-id="element-1954" />
                Register
              </Link>
            </div>
          </div>}
        {/* Search and Filter */}
        <div className="mb-6" data-id="element-1955">
          <div className="relative mb-4" data-id="element-1956">
            <input type="text" placeholder="Search discussions..." className="w-full p-3 pl-10 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-800 dark:text-gray-200" data-id="element-1957" />
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-1958" />
            <button className="absolute right-3 top-1/2 transform -translate-y-1/2" data-id="element-1959">
              <FilterIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-1960" />
            </button>
          </div>
          <div className="flex justify-between items-center mb-4" data-id="element-1961">
            <div className="flex overflow-x-auto space-x-2 pb-2" data-id="element-1962">
              <button onClick={() => setActiveTab('all')} className={`px-3 py-1 border rounded-full whitespace-nowrap text-sm ${activeTab === 'all' ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-1963">
                All Topics
              </button>
              <button onClick={() => setActiveTab('trending')} className={`px-3 py-1 border rounded-full whitespace-nowrap text-sm flex items-center ${activeTab === 'trending' ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-1964">
                <TrendingUpIcon className="w-3 h-3 mr-1" data-id="element-1965" />
                Trending
              </button>
              <button onClick={() => setActiveTab('latest')} className={`px-3 py-1 border rounded-full whitespace-nowrap text-sm ${activeTab === 'latest' ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-1966">
                Latest
              </button>
              <button onClick={() => setActiveTab('unanswered')} className={`px-3 py-1 border rounded-full whitespace-nowrap text-sm ${activeTab === 'unanswered' ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'border-gray-300 dark:border-gray-600 dark:text-gray-200'}`} data-id="element-1967">
                Unanswered
              </button>
            </div>
            <Link to={isLoggedIn ? '/forum/new' : '/register'} className="flex items-center px-3 py-1 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md text-sm" data-id="element-1968">
              <PlusIcon className="w-4 h-4 mr-1" data-id="element-1969" />
              New Topic
            </Link>
          </div>
        </div>
        {/* Topics List */}
        <div className="mb-6" data-id="element-1970">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-1971">
            Popular Discussions
          </h2>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden divide-y divide-gray-300 dark:divide-gray-600" data-id="element-1972">
            {topics.map(topic => <div key={topic.id} className="p-4 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1973">
                <div className="flex items-start" data-id="element-1974">
                  <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-3" data-id="element-1975">
                    {topic.authorAvatar ? <img src={topic.authorAvatar} alt={topic.author} className="w-full h-full rounded-full object-cover" data-id="element-1976" /> : <UserIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-1977" />}
                  </div>
                  <div className="flex-1" data-id="element-1978">
                    <div className="flex items-center mb-1" data-id="element-1979">
                      <span className="text-xs bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-2 py-0.5 rounded-full mr-2" data-id="element-1980">
                        {topic.category}
                      </span>
                      {topic.isHot && <span className="text-xs bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-2 py-0.5 rounded-full mr-2 flex items-center" data-id="element-1981">
                          <TrendingUpIcon className="w-3 h-3 mr-1" data-id="element-1982" />
                          Hot
                        </span>}
                      {topic.isPinned && <span className="text-xs bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-2 py-0.5 rounded-full flex items-center" data-id="element-1983">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1" data-id="element-1984">
                            <path d="M12 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" data-id="element-1985" />
                            <path d="M12 2v2" data-id="element-1986" />
                            <path d="m4.93 4.93 1.41 1.41" data-id="element-1987" />
                            <path d="M2 12h2" data-id="element-1988" />
                            <path d="m4.93 19.07 1.41-1.41" data-id="element-1989" />
                            <path d="M12 18v2" data-id="element-1990" />
                          </svg>
                          Pinned
                        </span>}
                    </div>
                    <Link to={isLoggedIn ? `/forum/topic/${topic.id}` : '/register'} className="font-medium mb-1 block dark:text-gray-200" data-id="element-1991">
                      {topic.title}
                    </Link>
                    <div className="flex items-center text-xs text-gray-500 dark:text-gray-400" data-id="element-1992">
                      <span data-id="element-1993">By {topic.author}</span>
                      <span className="mx-2" data-id="element-1994">•</span>
                      <span data-id="element-1995">{topic.lastActivity}</span>
                    </div>
                  </div>
                  <div className="flex flex-col items-end ml-4" data-id="element-1996">
                    <div className="flex items-center text-sm" data-id="element-1997">
                      <MessageSquareIcon className="w-4 h-4 mr-1 text-gray-500 dark:text-gray-400" data-id="element-1998" />
                      <span className="dark:text-gray-300" data-id="element-1999">
                        {topic.replies}
                      </span>
                    </div>
                    <div className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-2000">
                      {topic.views} views
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="mt-4 text-center" data-id="element-2001">
            <Link to="/forum/topics" className="text-sm text-gray-800 dark:text-gray-200 hover:underline" data-id="element-2002">
              View all topics
            </Link>
          </div>
        </div>
        {/* Categories */}
        <div className="mb-6" data-id="element-2003">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-2004">
            Categories
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2005">
            {categories.map(category => <Link key={category.id} to={`/forum/category/${category.id}`} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 hover:bg-gray-50 dark:hover:bg-gray-700 flex justify-between items-center" data-id="element-2006">
                <div data-id="element-2007">
                  <h3 className="font-medium dark:text-gray-200" data-id="element-2008">
                    {category.name}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-2009">
                    {category.topics} topics • {category.posts} posts
                  </p>
                </div>
                <ChevronRightIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-2010" />
              </Link>)}
          </div>
        </div>
        {/* Community Guidelines */}
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 bg-gray-50 dark:bg-gray-800" data-id="element-2011">
          <h3 className="font-medium mb-2 dark:text-gray-200" data-id="element-2012">
            Community Guidelines
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-3" data-id="element-2013">
            Please follow these guidelines to ensure a positive experience for
            everyone:
          </p>
          <ul className="text-sm text-gray-600 dark:text-gray-400 space-y-1 list-disc pl-5" data-id="element-2014">
            <li data-id="element-2015">Be respectful and considerate of others</li>
            <li data-id="element-2016">Stay on topic and avoid spamming</li>
            <li data-id="element-2017">No hate speech, harassment, or inappropriate content</li>
            <li data-id="element-2018">Respect privacy and do not share personal information</li>
            <li data-id="element-2019">Follow JoinToday's Terms of Service</li>
          </ul>
        </div>
      </div>
    </div>;
};
export default Forum;